module.exports = __webpack_public_path__ + "img/1970East-026_WEB-min.d773e9c0.jpg";